import { render, staticRenderFns } from "./CartSidebar.vue?vue&type=template&id=6b2153ae&scoped=true"
import script from "./CartSidebar.vue?vue&type=script&lang=js"
export * from "./CartSidebar.vue?vue&type=script&lang=js"
import style0 from "./CartSidebar.vue?vue&type=style&index=0&id=6b2153ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2153ae",
  null
  
)

export default component.exports